import {
    APIProvider,
    Map,
    MapCameraChangedEvent,
    Marker,
} from "@vis.gl/react-google-maps";
import "./map.scss";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { latLong } from "../../types/estate";
import { useEffect, useRef, useState } from "react";

const MapPage = () => {
   
    const [searchParams] = useSearchParams();
    const [apiLoaded, setApiLoaded] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const state = location.state;
    const defaultLocation: latLong = { lat: 51.5074, lng: -0.1278 };
    const lat =
        parseFloat(searchParams.get("lat") || "") || defaultLocation.lat;
    const lng =
        parseFloat(searchParams.get("lng") || "") || defaultLocation.lng;
    const unitLocation: latLong = { lat, lng };
    const zoom = parseFloat(searchParams.get("zoom") || "") || 12;
    const handleBack = () => {
        navigate(-1);
    };

    

    useEffect(() => {
        console.log(location.state);
        console.log(location);
        console.log(unitLocation);
    }, []);

    return (
        <div className="contain-wrapper">
            <div className="map-wrapper contain">
                <a onClick={handleBack} className="volt-button map-back-btn">
                    <p>Back</p>
                </a>
                <APIProvider
                    apiKey={"AIzaSyBs9fOEZFVmtgCQT32tig-RtnryKmiWyjk"}
                    onLoad={() => {
                        console.log("Maps API has loaded.");
                        setApiLoaded(true);
                    }}                >
                    <Map
                        defaultZoom={zoom || 12}
                        defaultCenter={{
                            lat: unitLocation.lat,
                            lng: unitLocation.lng,
                        }}
                        fullscreenControl={false}
                        disableDefaultUI={true}
                        zoomControl={true}
                        styles={[
                            {
                                "featureType": "all",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "saturation": 36
                                    },
                                    {
                                        "color": "#000000"
                                    },
                                    {
                                        "lightness": 40
                                    }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#000000"
                                    },
                                    {
                                        "lightness": 16
                                    }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "lightness": 20
                                    },
                                    {
                                        "color": "#000000"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    },
                                    {
                                        "lightness": 17
                                    },
                                    {
                                        "weight": 1.2
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "labels",
                                "stylers": [
                                    {
                                        "visibility": "simplified"
                                    },
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": "-50"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#0b2f36"
                                    },
                                    {
                                        "lightness": "4"
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    },
                                    {
                                        "lightness": 21
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "labels",
                                "stylers": [
                                    {
                                        "visibility": "simplified"
                                    },
                                    {
                                        "lightness": "-50"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": "-50"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "weight": "7.96"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#0b2f36"
                                    },
                                    {
                                        "lightness": "-29"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    },
                                    {
                                        "lightness": 29
                                    },
                                    {
                                        "weight": 0.2
                                    },
                                    {
                                        "visibility": "simplified"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "saturation": "-30"
                                    },
                                    {
                                        "gamma": "1.00"
                                    },
                                    {
                                        "lightness": "0"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#0b2f36"
                                    },
                                    {
                                        "lightness": "-29"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#0b2f36"
                                    },
                                    {
                                        "lightness": "-29"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#000000"
                                    },
                                    {
                                        "lightness": 19
                                    }
                                ]
                            },
                            {
                                "featureType": "transit.line",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#0b2f36"
                                    },
                                    {
                                        "lightness": "-18"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit.station.rail",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#ff0000"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#0f252e"
                                    },
                                    {
                                        "lightness": 17
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "labels",
                                "stylers": [
                                    {
                                        "color": "#0b2f36"
                                    },
                                    {
                                        "lightness": "29"
                                    }
                                ]
                            }
                        ]}
                        onCameraChanged={(ev: MapCameraChangedEvent) =>
                            console.log(
                                "camera changed:",
                                ev.detail.center,
                                "zoom:",
                                ev.detail.zoom
                            )
                        }
                    >
                       
                       {apiLoaded && window.google && (
                            <Marker
                                position={{ lat, lng }}
                                title="Default Location"
                                icon={{
                                    url: "/ui/map-pin.svg",
                                    scaledSize: new window.google.maps.Size(
                                        40,
                                        40
                                    ),
                                }}
                            />
                        )}
                      
                    </Map>
                </APIProvider>
            </div>
        </div>
    );
};

export default MapPage;
